<template>
  <div class="album-container">
    <a-spin :spinning="loading">
      <div class="album-main">
        <div class="album-thumbnail">
          <div class="album-thumbnail_list">
            <div v-for="(item, index) in albumTempInfo.page_views" :key="`thumbnail_${item.id}`">
              <a-dropdown :trigger="['contextmenu']">
                <div class="album-thumbnail_item_box" :class="{ 'selected-page': curPage === index + 1 }">
                  <span class="album-thumbnail_item" :class="{ 'selected-page': curPage === index + 1 }"
                    :style="getBgStyle(item.background_image.thumbnail_url)" @click="pageChange(index)">
                    <i>{{ index + 1 }}</i>
                  </span>
                </div>
                <a-menu slot="overlay">
                  <a-menu-item key="copy" class="width-100 align-center" @click="copyHandle">复制</a-menu-item>
                  <a-menu-item key="delete" class="width-100 align-center" @click="delHandle(item.id)">删除</a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </div>
        <div class="album-content">
          <div v-for="(pageView, page) in albumTempInfo.page_views" :key="pageView.id" class="album-item"
            :style="getPageStyle(pageView)" v-if="curPage === page + 1">
            <div v-for="section in pageView.section_views" :key="section.template_section_id">
              <div v-for="fieldView in section.field_views" :key="fieldView.template_field_id">
                <div v-if="fieldView.type === 'text'" class="album-item_field" :style="getFieldStyle(pageView, fieldView)"
                  @click="fieldClickHandle(pageView, section, fieldView)">{{ getFieldValue(fieldView) }}</div>

                <a-dropdown v-else  :trigger="['contextmenu']">
                  <div class="album-item_field" :style="getFieldStyle(pageView, fieldView)" @click="fieldClickHandle(pageView, section, fieldView)">{{ getFieldValue(fieldView) }}</div>
                  <a-menu v-if="fieldView.default_image" slot="overlay">
                    <a-menu-item key="copy" class="width-100 align-center" @click="imageEditHandle(pageView, section, fieldView)">图片编辑</a-menu-item>
                    <a-menu-item key="delete" class="width-100 align-center" @click="delPageImage">删除</a-menu-item>
                  </a-menu>
              </a-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="album-sider scroll-bar">
          <span class="album-sider_name m-bottom-30">{{ klassInfo.name }}</span>
          <div class="album-sider_label">
            <span>手册模板名称</span>
            <svg-icon class="album-sider_edit" iconClass="edit" @click="updateHandle"></svg-icon>
          </div>
          <a-textarea ref="nameRef" v-if="nameEditStatus" v-model="albumTempTitle" placeholder="请输入内容"
            :auto-size="{ minRows: 3 }" style="resize: none" @blur="onBlurHandle" />
          <span class="album-sider_name" v-else>{{ albumTempInfo.title }}</span>
          <div style="height: 1px;">
            <a-divider class="album-sider_divider"></a-divider>
          </div>
          <div v-if="fieldView && fieldView.type === 'text' && isLeftClick">
            <span class="album-sider_label">文本内容</span>
            <a-textarea v-model="fieldView.default_value" placeholder="请输入内容" :auto-size="{ minRows: 3 }" style="resize: none"
              @blur="updatePageInfo()" />
            <span class="album-sider_label">字体大小</span>
            <a-slider v-model="fieldView.default_style.font_size" :min="10" :max="100" @blur="updatePageInfo()" />
            <a class="m-top-10 album-sider_select" href="javascript:;" @click="selectHandle">从班级圈选择>></a>
          </div>
          <div v-if="fieldView && fieldView.type === 'image' && isLeftClick">
            <span class="album-sider_label">图片编辑</span>
            <img v-if="fieldView.default_image" class="album-sider_image cursour" @click="viewPhoto" :src="fieldView.default_image.url" />
            <a-upload v-else :customRequest="event => customRequest(event, 'background_image_url')"
              list-type="picture-card" :show-upload-list="false">
              <div class="album-sider_image">
                <svg-icon iconClass="plus"></svg-icon>
              </div>
            </a-upload>
            <a class="m-top-10 album-sider_select" href="javascript:;" @click="selectHandle">从班级圈选择>></a>
            <a-upload v-if="fieldView.default_image" :customRequest="event => customRequest(event, 'background_image_url')"
              list-type="picture-card" :show-upload-list="false">
              <a class="m-top-10 album-sider_select" href="javascript:;">上传本地图片</a>
            </a-upload>
          </div>

          <span class="flex-empty"></span>
        </div>
      </div>
    </a-spin>

    <a-modal title="图片编辑" v-model="imageModalInfo.visible" :confirm-loading="imageModalInfo.loading" :width="800" centered
      destroyOnClose>
      <div class="album-editor">
        <image-editor :klassId="klassId" :image-url="imageUrl" :scale="imageModalInfo.scale"
          @cropperHandle="cropperHandle" />
      </div>
      <template slot="footer">
        <div></div>
      </template>
    </a-modal>

    <a-modal :title="modalInfo.title" v-model="modalInfo.visible" :confirm-loading="modalInfo.loading" :width="800"
      :bodyStyle="{ background: '#f5f5f5' }" centered destroyOnClose>
      <modal-klass-circle :klassId="klassId" :fieldType="fieldType" :selectedView.sync="selectedView" />
      <template slot="footer">
        <div>
          <a-button @click="cancelHandle">取消</a-button>
          <a-button type="primary" :disabled="!selectedView.length" @click="okHandle">确定</a-button>
        </div>
      </template>
    </a-modal>

    <app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
  </div>
</template>

<script>
import AppViewImg from "@/components/AppViewImg"
import AlbumTempService from "@/api/albumTempService"
import KlassService from "@/api/klassService"
import ImageEditor from "./imageEditor"
import modalKlassCircle from "./modalKlassCircle.vue"
import { uploadHandle } from "@/utils"
import dict from "@/config"
import albumMixins from "./albumMixins"
export default {
  name: "album",
  mixins: [albumMixins],
  components: { ImageEditor, modalKlassCircle, AppViewImg },
  data() {
    return {
      imageList: [],
      imageIndex: 0,
      ALBUM_DIGTAL_STATUS: dict.ALBUM_DIGTAL_STATUS,
      klassId: undefined,
      albumId: undefined,
      pageViewList: [],
      curPage: 1,
      loading: false,
      klassInfo: {},
      studentInfo: {},
      albumInfo: {},
      pageView: null,
      childPageView: null,
      fieldView: null,
      sectionView: [],
      isLeftClick: false,
      fontSize: 0,
      imageModalInfo: {
        visible: false,
        loading: false,
        scale: 1
      },
      imageUrl: "",
      modalInfo: {
        title: "从班级圈获取图片",
        visible: false,
        loading: false
      },
      fieldType: "text",
      selectedView: [],
      imageLen: 1,
      nameEditStatus: false,

      albumTempInfo: {
        page_views: []
      }
    }
  },
  mounted() {
    this.initHandle()
  },
  methods: {
    initHandle() {
      this.klassId = this.$route.query.klass_id
      this.albumTempId = this.$route.query.id
      this.albumId = this.$route.query.id
      this.getKlassInfo()
      this.getAlbumTempHandle()
    },
    getKlassInfo() {
      KlassService.getKlassInfoService({ klassId: this.klassId }).then(res => {
        this.klassInfo = res
      })
    },

    getAlbumTempHandle() {
      this.loading = true
      AlbumTempService.getAlbumTempService({ tempId: this.albumTempId })
        .then(res => {
          this.albumTempInfo = res
          this.curPage = Math.min(this.curPage, res.page_views.length)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    pageChange(index) {
      this.curPage = index + 1
      this.isLeftClick = false
    },

    delHandle(pageId) {
      this.$confirm({
        title: "提示信息",
        content: "是否删除当前页",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise((resolve, reject) => {
            this.loading = true
            AlbumTempService.delAlbumTempPageInfoService({ tempId: this.albumTempId, pageId })
              .then(() => {
                this.getAlbumTempHandle()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    copyHandle() {
      this.$confirm({
        title: "提示信息",
        content: "是否复制当前页",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            let pageViews = this.getAlbumTempBody(this.albumTempInfo.page_views)
            const copyPage = this.getAlbumTempPage(this.albumTempInfo.page_views[this.curPage - 1], true)
            pageViews.splice(this.curPage, 0, copyPage)
            pageViews.forEach((item, index) => {
              item.id = index + 1
            })
            AlbumTempService.updateAlbumTempService({ tempId: this.albumTempId, title: this.albumTempInfo.title, pages: pageViews })
              .then(() => {
                this.getAlbumTempHandle()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    delPageImage() {
      this.$confirm({
        title: "删除图片",
        content: "是否删除此图片",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.fieldView.default_image = null
          return new Promise(async (resolve, reject) => {
            const result = await this.updatePageInfo(true)
            if (result) {
              resolve()
            } else {
              reject(result)
            }
          })
        }
      })
    },

    imageEditHandle(pageView, section, fieldView) {
      this.fieldClickHandle(pageView, section, fieldView)
      this.$nextTick(() => {
        this.imageModalInfo.visible = true
        this.imageModalInfo.scale = this.fieldView.width / this.fieldView.height
        setTimeout(() => {
          this.imageUrl = this.fieldView.default_image.url
        }, 500)
      })
    },

    async updatePageInfo(forceUpdate = false) {
      this.loading = true
      const pageView = this.albumTempInfo.page_views[this.curPage - 1]
      let result = await AlbumTempService.updateAlbumTempPageService({ tempId: this.albumTempId, ...this.getAlbumTempPage(pageView) })

      if (result && result.id) {
        this.$message.success("操作成功")
      } else {
        this.$message.error("操作失败，请重新操作")
        return false
      }

      if (forceUpdate) {
        this.getAlbumTempHandle()
      } else {
        this.loading = false
      }
      return true
    },

    fieldClickHandle(pageView, sectionView, fieldView) {
      this.pageView = pageView
      this.fieldView = fieldView
      this.sectionView = sectionView
      this.isLeftClick = true
      if (fieldView.type === "image") {
        this.imageModalInfo.scale = this.fieldView.width / this.fieldView.height
      }
    },

    customRequest(event) {
      this.loading = true
      uploadHandle({ file: event.file, klassId: this.klassId })
        .then(imageObj => {
          this.fieldView.default_image = imageObj
          this.updatePageInfo(true)
        })
        .catch(() => {
          this.loading = false
        })
    },

    selectHandle() {
      this.selectedView = []
      let title = "从班级圈获取内容"
      if (this.fieldView.type === "image") {
        title = "从班级圈获取图片"
      }
      this.fieldType = this.fieldView.type
      this.modalInfo = {
        visible: true,
        loading: false,
        title
      }
    },

    cancelHandle() {
      this.modalInfo.visible = false
    },

    okHandle() {
      this.loading = true
      if (this.fieldView.type === "text") {
        this.fieldView.default_value = `${this.selectedView[0].tags.map(item => "#" + item.name).join(",")} ${this.selectedView[0].content}`
        this.updatePageInfo()
      } else {
        this.fieldView.default_image = this.selectedView[0]
        this.updatePageInfo(true)
      }
      this.modalInfo.visible = false
    },

    updateAlbumInfoHandle() {
      if (!this.albumTempTitle || !this.albumTempTitle.trim().length) {
        this.$message.warning("请输入模板名称")
        return
      }
      AlbumTempService.updateAlbumTempService({ tempId: this.albumTempId, title: this.albumTempTitle.trim(), pages: this.getAlbumTempBody(this.albumTempInfo.page_views) })
        .then(() => {
          this.$message.success("操作成功")
          this.nameEditStatus = false
          this.albumTempInfo.title = this.albumTempTitle.trim()
        })
        .catch(() => {
          this.$message.error("操作失败，请重新操作")
        })
    },

    updateHandle() {
      this.nameEditStatus = true
      this.albumTempTitle = this.albumTempInfo.title
      this.$nextTick(() => {
        this.$refs.nameRef.focus()
      })
    },
    onBlurHandle() {
      if (this.albumTempTitle !== this.albumTempInfo.title) {
        this.updateAlbumInfoHandle()
      } else {
        this.nameEditStatus = false
      }
    },

    cropperHandle(source) {
      this.loading = true
      this.imageModalInfo.visible = false
      this.fieldView.default_image = source
      this.updatePageInfo(true)
    },

    downloadHandle() {
      window.open(this.albumInfo.digital_copy.url, "_blank")
    },

    viewPhoto() {
      const imageList = []
      for (let i = 0; i < this.pageView.section_views.length; i++) {
        for (let j = 0; j < this.pageView.section_views[i].field_views.length; j++) {
          const { type, default_image } = this.pageView.section_views[i].field_views[j]
          if (type === "image" && default_image) {
            imageList.push(default_image.url)
          }
        }
      }

      this.imageList = imageList
      this.imageIndex = this.imageList.findIndex(item => item === this.fieldView.default_image.url)
    }
  }
}
</script>

<style lang="less" scoped>
.album {
  &-container {
    min-width: 980px;

    /deep/.ant-upload {
      display: block;
      margin: 0;
      padding: 0 !important;
      border: none;

      &:hover {
        border: none;
      }
    }

    /deep/.ant-upload-picture-card-wrapper {
      display: block;
      // height: 120px;
    }

    /deep/.ant-upload-select-picture-card {
      height: auto;
      background: transparent;
    }
  }

  &-main {
    display: flex;
    flex-flow: nowrap row;
    height: calc(100vh - 150px);
    padding-bottom: 20px;
    margin: 15px 100px 0 0;
  }

  &-thumbnail {
    width: 165px;
    background: #e9e9e9;
    overflow-x: hidden;

    &_list {
      width: 185px;
      height: 100%;
      overflow: auto;
    }

    &_item {
      display: block;
      width: 107px;
      height: 143px;
      line-height: 143px;
      cursor: pointer;
      background-size: cover !important;
      font-size: 12px;
      border: 1px solid transparent;

      // box-shadow: 0 4px 12px rgb(0 0 0 / 15%);
      &_box {
        width: 111px;
        margin: 17px 0 17px 33px;
        border: 2px solid transparent;

        &.selected-page {
          border: 2px solid rgba(183, 71, 42, 0.9);
        }
      }

      i {
        margin-left: -20px;
        color: #343c6a;
      }

      &.selected-page {
        border: 1px solid white;
      }
    }
  }

  &-content {
    flex-grow: 1;
  }

  &-sider {
    display: flex;
    flex-flow: nowrap column;
    width: 240px;
    margin: 20px 0 0 20px;
    padding: 10px 27px 20px 17px;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;

    &_name {
      display: block;
      color: #3d3d3d;
      font-weight: bold;
      font-size: 14px;
    }

    &_label {
      display: block;
      margin: 15px 0;
      color: #343c6a;
      font-size: 14px;
    }

    &_select {
      display: block;
      color: #01acfc;
    }

    &_edit {
      margin-top: 3px;
      font-size: 14px;
      float: right;
      cursor: pointer;
    }

    &_image {
      display: block;
      width: 206px;
      // height: 120px;
      border-radius: 4px;
      background: #ececee;
      font-size: 40px;
      line-height: 120px;
      background-size: cover !important;
    }

    &_divider {
      width: calc(100% + 44px);
      margin: 10px -27px 10px -17px;
      background: #d9d9d9;
    }

    &_confirm {
      width: 200px;
      margin-top: 20px;
      // position: fixed;
      // bottom: 70px;
    }

    &_status {
      display: flex;
      flex-flow: nowrap row;
      align-items: center;
      justify-content: space-between;
      margin: 15px 0;
      font-weight: bold;
      font-size: 14px;
    }
  }

  &-item {
    position: relative;
    display: block;
    margin: 50px auto;
    background-size: cover !important;

    &_field {
      border: 1px dashed #999;
      cursor: pointer;
    }
  }

  &-editor {
    height: 600px;
  }
}

#album {
  width: 375px;
  margin: 50px 100px 30px;
  overflow: hidden;
}
</style>
